import { CheckIcon } from "lucide-react";

import style from "./Steps.module.css";

const Step = ({ step, isActive, isCompleted, index }) => {
  return (
    <li className={`${style.step} ${isActive ? style.stepActive : ""}`}>
      {isCompleted ? (
        <div className={style.stepNumberCompleted}>
          <CheckIcon
            style={{ width: "16px", height: "16px", color: "white" }}
          />
        </div>
      ) : (
        <div
          className={`${style.stepNumber} ${
            isActive ? style.stepNumberActive : ""
          }`}
        >
          {index}
        </div>
      )}
      <p className={style.stepName}>{step}</p>
    </li>
  );
};

export const Steps = ({
  activeStep,
  isLungsReferral,
  isProstateReferral,
  isSpecialistReferral,
}) => {
  return (
    <ul
      className={`${style.stepsWrapper} ${
        isLungsReferral || isSpecialistReferral || isProstateReferral
          ? style.stepsWrapper5
          : ""
      }`}
    >
      <Step
        step="General Information"
        isActive={activeStep === "generalInformation"}
        isCompleted={
          activeStep === "review" ||
          activeStep === "referralForm" ||
          activeStep === "patientDetails" ||
          activeStep === "lungsDetails" ||
          activeStep === "prostateDetails" ||
          activeStep === "additionalInformations"
        }
        index={1}
      />
      <Step
        step="Patient Details"
        isActive={activeStep === "patientDetails"}
        isCompleted={
          activeStep === "referralForm" ||
          activeStep === "review" ||
          activeStep === "referralForm" ||
          activeStep === "lungsDetails" ||
          activeStep === "prostateDetails"
        }
        index={2}
      />
      <Step
        step="Referral Form"
        isActive={activeStep === "referralForm"}
        isCompleted={
          activeStep === "review" ||
          activeStep === "lungsDetails" ||
          activeStep === "prostateDetails" ||
          activeStep === "additionalInformations"
        }
        index={3}
      />
      {isLungsReferral && (
        <Step
          step="Lungs Details"
          isActive={activeStep === "lungsDetails"}
          isCompleted={
            activeStep === "review" || activeStep === "additionalInformations"
          }
          index={isLungsReferral || isProstateReferral ? 4 : 3}
        />
      )}
      {isProstateReferral && (
        <Step
          step="Prostate Details"
          isActive={activeStep === "prostateDetails"}
          isCompleted={
            activeStep === "review" || activeStep === "additionalInformations"
          }
          index={isLungsReferral || isProstateReferral ? 4 : 3}
        />
      )}
      <Step
        step="Review"
        isActive={activeStep === "review"}
        isCompleted={activeStep === "additionalInformations"}
        index={isLungsReferral || isProstateReferral ? 5 : 4}
      />
      {isSpecialistReferral && (
        <Step
          step="Specialist Referral"
          isActive={activeStep === "specialistReferral"}
          isCompleted={false}
          index={isLungsReferral || isProstateReferral ? 6 : 5}
        />
      )}
    </ul>
  );
};
